module.exports = __webpack_public_path__ + "img/Butterfly_00178.6c2da0ef.png";